import React, { useState, useEffect } from "react";

import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from "axios";
import { DocumentTypes } from "../enums/DocumentTypes";


// ������� ��������

const allDocuments = async (postData: DocumentTypes[] = null) => {
    const { data } = await axios.post('/DocumentApi/GetDocuments', postData);
    return data;
};

const addDocument = async (postData: { File: File, Comment?: string, Name: string, DocumentTypeId: DocumentTypes }) => {
    const formData = new FormData();
    formData.append("DocumentFile", postData.File);
    formData.append("Comment", postData.Comment || '');
    formData.append("Title", postData.Name);
    formData.append("DocumentTypeId", postData.DocumentTypeId.toString());

    const { data } = await axios.post("/DocumentApi/AddDocument", formData);
    return data;
}

//const addDocToLot = async (postData: {
//    File: File,
//    Comment?: string,
//    Name: string,
//    DocumentTypeId: DocumentTypes,
//    lotId: string
//}) => {
//    const formData = new FormData();
//    formData.append("model", JSON.stringify({
//        Comment: postData.Comment,
//        Name: postData.Name,
//        DocumentTypeId: postData.DocumentTypeId
//    }))
//    formData.append("file", postData.File);
//    formData.append("lotId", postData.lotId);
//    const { data } = await axios.post('/MyActivityApi/AddDocumentToLot', postData);
//    return data;
//};

const linkDocToLot = async (postData: { documentId: string, lotId: string }) => {
    const formData = new FormData();
    formData.append("documentId", postData.documentId);
    formData.append("lotId", postData.lotId);

    const { data } = await axios.post('/MyActivityApi/LinkDocumentLot', formData);
    return data;
};

const unLinkDocToLot = async (postData: { documentId: string | number, lotId: string | number }) => {
    const formData = new FormData();
    formData.append("documentId", postData.documentId.toString());
    formData.append("lotId", postData.lotId.toString());

    const { data } = await axios.post('/MyActivityApi/UnLinkDocumentLot', formData);
    return data;
};



// ����

export const useGetAllDocuments = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: allDocuments,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['documents'] }),
    });
};

export const useAddDocument = () => {
    const queryClient = useQueryClient();

    const mutation = useMutation({
        mutationFn: addDocument,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['addDocument'] }),
    });

    return {
        ...mutation,
        error: mutation.error?.response?.data?.Error || mutation.error?.message || "����������� ������",
    };
};

export const useLinkDocToLot = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: linkDocToLot,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['linkDocToLot'] }),
    });

    return {
        ...mutation,
        error: mutation.error?.response?.data?.Error || mutation.error?.message || "����������� ������",
    };
};

export const useUnLinkDocToLot = () => {
    const queryClient = useQueryClient();
    const mutation = useMutation({
        mutationFn: unLinkDocToLot,
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['UnLinkDocToLot'] }),
    });

    return {
        ...mutation,
        error: mutation.error?.response?.data?.Error || mutation.error?.message || "����������� ������",
    };
};